import { render, staticRenderFns } from "./progress_bar.vue?vue&type=template&id=8b74aaf8&scoped=true&"
import script from "./progress_bar.vue?vue&type=script&lang=js&"
export * from "./progress_bar.vue?vue&type=script&lang=js&"
import style0 from "./progress_bar.vue?vue&type=style&index=0&id=8b74aaf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b74aaf8",
  null
  
)

export default component.exports